import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import FieldLegoChip from './FieldLegoChip';
import { flattenErpFieldRows } from '../../utils/erpFieldTree';

const ErpFieldTree = ({ samplePayload, searchQuery, selectedPath, onSelectPath, disabled }) => {
  const rows = useMemo(() => flattenErpFieldRows(samplePayload, searchQuery), [samplePayload, searchQuery]);

  if (!samplePayload) {
    return (
      <Typography variant="body2" color="text.secondary">
        Upload a sample ERP payload on the previous step to see source fields.
      </Typography>
    );
  }

  if (!rows.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No ERP fields match your search.
      </Typography>
    );
  }

  return (
    <Box>
      {rows.map((node) => (
        <FieldLegoChip
          key={`${node.path}:${node.arrayRootPath || 'root'}`}
          node={node}
          selected={selectedPath === node.path}
          onSelect={(selected) => onSelectPath?.(selected.path)}
          disabled={disabled}
        />
      ))}
    </Box>
  );
};

export default ErpFieldTree;
